<script lang="ts" setup>
import { ChecklistCriteria, CriteriaInstance } from "types/Checklist";

const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  checklistCriteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
});

const emits = defineEmits(["reportProblem"]);

const documentId = inject("documentId") as any;

const onReportProblem = (ev: any, isControl: boolean) => {
  emits("reportProblem", ev, isControl);
};

const store = useResultsForCriteriaIdStore(documentId, props.criteriaInstance);
const { requiresInstanceReview, isLoadingResults, evaluationResults } =
  storeToRefs(store);

const isLoading = computed(() => {
  return (
    props.checklistCriteria.evaluationMetricId != undefined &&
    (evaluationResults.value == undefined || isLoadingResults.value == true)
  );
});
</script>

<template>
  <div class="flex flex-col">
    <BaseLoading v-if="isLoading" class="grow" />
    <div v-if="isLoading != true" class="grow min-h-0 flex flex-col">
      <DocumentPanelChecklistParagraphScores
        v-if="requiresInstanceReview != true"
        :criteria-instance="criteriaInstance"
        :checklist-criteria="checklistCriteria"
        @reportProblem="onReportProblem"
        class="grow min-h-0"
      />
      <DocumentPanelChecklistParagraphInstanceReview
        v-if="requiresInstanceReview == true"
        :checklist-criteria="checklistCriteria"
        class="grow min-h-0"
      />
    </div>
  </div>
</template>

<style scoped></style>
